export default __webpack_public_path__ + "static/ut-fc5f2e44e81484c33428ad0248e6049a.mp4";